/**
 * Schuift elementen met `data-reveal` zacht in zodra ze in beeld komen.
 *
 * De waarde van het attribuut is de volgorde binnen een rij (0, 1, 2…): elk
 * volgend element komt 90ms later. Wat bij het laden al boven de vouw staat,
 * komt zonder vertraging. Zonder JavaScript, in de theme editor en bij
 * `prefers-reduced-motion` blijft alles direct zichtbaar (zie brand-styles).
 */
const STAGGER_MS = 90;

function init() {
  if (window.Shopify?.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const root = document.documentElement;
  if (root.classList.contains('reveal-ready')) return;

  /** @param {Element} element */
  const show = (element) => element.classList.add('is-revealed');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const element = /** @type {HTMLElement} */ (entry.target);
        const order = Number(element.dataset.reveal) || 0;
        element.style.setProperty('--reveal-delay', `${order * STAGGER_MS}ms`);
        show(element);
        observer.unobserve(element);
      }
    },
    { rootMargin: '0px 0px -40px 0px' }
  );

  /** @param {ParentNode} scope */
  const watch = (scope) => {
    for (const element of scope.querySelectorAll('[data-reveal]:not(.is-revealed)')) {
      // Al gepasseerd (bijv. na terugnavigeren halverwege de pagina): direct tonen.
      if (element.getBoundingClientRect().bottom < 0) show(element);
      else observer.observe(element);
    }
  };

  root.classList.add('reveal-ready');
  watch(document);

  // Secties die later binnenkomen (Section Rendering API, hydration).
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) watch(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
